module.exports = __webpack_public_path__ + "static/media/noBanner.235bee9f.png";